export const RELATED_ITEM_HEIGHT = 174;

export const RELATED_ITEMS_TRANSITION_TIMEOUT = 300;
